export enum FeedbackGrade {
  None = 0,
  ThumbDown = 1,
  ThumbUp = 5,
}
